module.exports = __webpack_public_path__ + "static/media/jk.6fd9835e.jpg";